import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import Tafsil from "../Accountings/Tafsil";
import GridConfig from "../GridConfig";

export default class Expenses extends Base {
    constructor(props) {
        super(props);
        this.state = {
            type: props.Type,
            caller: props.Caller,
            controllerName: 'expense',
            IsV2: true,
            data: null,
            loading: true,
            configName: 'expense_grid',
            moduleName: props.Type == 5 ? 'دفتر درآمد ها' : 'دفتر هزینه ها'
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
        this.state.filters = {
            type: this.state.type
        }
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.refreshData();
    }
    componentWillReceiveProps(props) {
        this.state.type = props.Type;
        this.state.filters.type = this.state.type;
        this.refreshData();
    }
    async refreshData(e, action = 'tafsils', outputFormat = 'json') {
        if (!this.isNull(e)) e.preventDefault();
        this.setState({ loading: true });

        this.httpPost('api/v1/' + this.state.controllerName + '/' + action, {
            page: this.state.page,
            count: this.state.per_page,
            phrase: this.state.phrase,
            filters: this.state.filters,
            outputFormat,
        }).then((data) => {
            if (data.status === -1) window.location.href = '/login';
            if (data.status === 0) {
                this.setState({
                    selectedIds: [],
                    loading: false,
                });
            } else {
                if (outputFormat == 'excel') this.downloadExcel(data.bs64);
                if (outputFormat == 'json') {
                    this.state.data = data;
                }
                this.setState({
                    loading: false,
                });
            }
        });
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Tafsil TafsilType={this.state.type} Caller={this} Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <Tafsil TafsilType={this.state.type} Caller={this} /> });
    }
    onGridConfig() {
        this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "title", caption: "عنوان", show: true },
                { field: "code", caption: "کد", show: true },
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'title' && f.show) t.push({ field: f.field, headerName: f.caption, cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.onEdit(props.data.id)}>{props.data.title}</a> } });
            if (f.field == 'code' && f.show) t.push({ field: f.field, headerName: f.caption });
        });
        return t;
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "width": "96%" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            {this.state.type === 6 && <h4 className="modal-title">دفتر هزینه</h4>}
                            {this.state.type === 5 && <h4 className="modal-title">دفتر درآمد</h4>}
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                {this.getToolBar(false, { add: true, print: false, pdf: false, excell: false, remove: false, config:false, otherFilters: null })}
                                {this.renderAgGrid({
                                    columnDefs: this.getColumns()
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
                this.renderPopupComponent()
            ];

        return contents;
    }
}